import axios from "axios";

import config from "./config";

export default class ProcedimentosService {
  static async getProcedimentos(especialidade, search) {
    const bodyFormData = new FormData();
    bodyFormData.append("servico", "getProcedimentos");
    bodyFormData.append("codesp", especialidade);
    bodyFormData.append("busca", search);
    let response = "";
    try {
      response = await axios.post(config.API_URL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
      return {status: false, error:err};
    }
    return response.data
  }
}
